// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SupplementalRelation = function (x) {
    return x;
};
var tsBridgeSupplementalRelat = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SupplementalRelation")("__brandSupplementalRelation"));
    }
};
var writeSupplementalRelation = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSupplementalRelation = Data_Show.showString;
var readSupplementalRelation = Simple_JSON.readString;
var ordSupplementalRelation = Data_Ord.ordString;
var newtypeSupplementalRelation = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSupplementalRelation = SupplementalRelation;
var eqSupplementalRelation = Data_Eq.eqString;
export {
    SupplementalRelation,
    makeSupplementalRelation,
    unwrap,
    newtypeSupplementalRelation,
    eqSupplementalRelation,
    ordSupplementalRelation,
    showSupplementalRelation,
    readSupplementalRelation,
    writeSupplementalRelation,
    tsBridgeSupplementalRelat
};
//# sourceMappingURL=index.js.map
